export default __webpack_public_path__ + "static/markedwaxwithdust-984c85d2ad6f9d2715a49b88f56f8d69.png";